/**
 * 按钮显隐：比对当前用户菜单里 type=2 节点的 path。
 */
import { usePermissionStore } from "@shared/store/modules/permission";
import { toUrlPath } from "@shared/router/mapUserMenus";

/** 当前登录用户是否拥有该按钮 path（空字符串不校验） */
export function hasPermission(path: string): boolean {
    if (!path) return true;
    const normalized = toUrlPath(path);
    if (!normalized) return true;
    return usePermissionStore().buttonPaths.includes(normalized);
}

/** 路由守卫：隐藏按钮页的 path 同样走按钮集合 */
export function hasButtonPermission(path: string): boolean {
    return hasPermission(path);
}
